/**
 * Created by amir on 8/27/18.
 */
export default class CloudUserService {
	static get $inject(){ return ['CookiesService']; }

	constructor(CookiesService){
		this.CookiesService = CookiesService;
		this.key = 'cloudUser';
	}

	saveUser(user){
		this.CookiesService.setCookie(this.key, user);
	}

	getUser(){
		return this.CookiesService.getCookie(this.key);
	}

	deleteUser(){
		this.CookiesService.removeCookie(this.key);
	}

}


/** WEBPACK FOOTER **
 ** ./src/services/app/CloudUser.service.js
 **/